import { styled } from '@mui/material';
import { someDeaNumError } from '.';
import {
  SuccessIcon,
  Error,
  IApiCallStatus,
  ErrorIcon,
  IDeaEditMode,
  IError,
} from '../common';
import { prop as lprop, defaultTo, compose as lcompose } from 'lodash/fp';

export function StatusSaveRequst({
  reqType,
  requestStatus,
  apiCallStatus,
  msgText,
  error,
  deaNos,
}: {
  reqType: string;
  requestStatus: string;
  apiCallStatus: IApiCallStatus;
  msgText: string | null;
  error?: IError;
  deaNos: IDeaEditMode[];
}) {
  return (
    <Wrapper>
      <span tabIndex={0}>Status: {requestStatus}</span>

      <span>
        {requestStatus === 'NEW' &&
          apiCallStatus === true &&
          (someDeaNumError(deaNos) === void 0 || reqType === 'REVOKE') && (
            <>
              <SuccessIcon />
            </>
          )}

        {requestStatus === 'SUBMITTED' && apiCallStatus === true && (
          <>
            <SuccessIcon /> {msgText}
          </>
        )}

        {requestStatus === 'NEW' &&
          apiCallStatus === true &&
          someDeaNumError(deaNos) !== void 0 &&
          reqType === 'ENROLL' && (
            <span tabIndex={0}>
              <ErrorIcon />
              <Error>
                Please review your DEA registration selection. There is at least
                one non-requestable DEA registration.
              </Error>
            </span>
          )}

        {apiCallStatus === false && (
          <span tabIndex={0}>
            <ErrorIcon />
            <Error>
              {lcompose(
                defaultTo('Error occured when saving or submitting request.'),
                lprop('message')
              )(error)}
            </Error>
          </span>
        )}
      </span>
    </Wrapper>
  );
}

const Wrapper = styled('article')(({ theme }) => ({
  '&>*+*': {
    marginLeft: '2rem',
  },
}));
